<template>
  <el-dialog :visible.sync="open" :title="$t('challenge.modal.create.title')" @closed="$emit('close')" :width="width" :append-to-body="true">
    <el-form>

      <div v-show="step === 1"
           style="display:flex;align-items:center">
        <div style="flex:1; text-align:center; border-right:1px dashed #aeaeae; padding:0 28px">
          <div style="margin: 36px 0">
            <font-awesome-icon icon="chess-knight" style="font-size:120px; color: #f5d76e;"></font-awesome-icon>
            <h1>{{$t('challenge.modal.informations')}}</h1>
          </div>
          <div style="line-height:1.8em;word-break: initial;">
            {{$t('challenge.modal.description_1')}}
          </div>
        </div>
        <div style="flex:1; text-align:center; padding:0 28px">

          <div class="form-group form-group-container-name" style="text-align:left">
            <label style="margin-bottom:8px;display:inline-block">{{ $t('common.name') }}</label>
            <el-input v-model="challenge.name[lang]"></el-input>
          </div>
          <div class="form-group form-group-container-description" style="text-align:left">
            <label style="margin-bottom:8px;display:inline-block">{{ $t('common.description') }}</label>
            <el-input type="textarea" v-model="challenge.description[lang]" :row="8"></el-input>
          </div>

          <div class="form-group-container-media">
            <label style="font-weight: 600;font-size: 14px;display:block;margin-bottom:8px;">{{ $t('common.avatar') }}</label>
            <div style="display:flex;">
              <div style="flex:1">
                <img v-bind:src="challenge.media.url" style="max-height:120px"/>
              </div>
              <div style="flex:1">
                <el-button class="button" @click="libraryOpened = !libraryOpened" size="small" plain="plain">Choose from library...</el-button>
              </div>
            </div>
            <library-manager v-show="libraryOpened"  :open="libraryOpened" @close="libraryOpened = false" @selected="imgSelected"></library-manager>
          </div>
        </div>
      </div>

      <div v-show="step === 2"
           style="display:flex;align-items:center">
        <div style="flex:1; text-align:center; border-right:1px dashed #aeaeae; padding:0 28px">
          <div style="margin: 36px 0">
            <font-awesome-icon icon="window-maximize" style="font-size:120px;color:#f5d76e;"></font-awesome-icon>
            <h1>{{$t('challenge.modal.popup')}}</h1>
          </div>
          <div style="line-height:1.8em;word-break: initial;">
            {{$t('challenge.modal.description_2')}}
          </div>
        </div>
        <div style="flex:1; text-align:center; padding:0 28px">
          <div class="form-group">
            <div class="form-group form-group-container-sentence_start" style="text-align:left;">
              <label style="margin-bottom:8px;display:block;"><el-switch v-model="sentenceStartEnable" />&nbsp;{{ $t('common.sentencestart') }}</label>
              <el-input type="textarea" v-if="!sentenceStartEnable" :disabled="true" :row="8"></el-input>
              <el-input type="textarea" v-model="challenge.sentence_start[lang]" v-if="sentenceStartEnable" :row="8"></el-input>
            </div>

            <div class="form-group form-group-container-sentence_dead" style="text-align:left;">
              <label style="margin-bottom:8px;display:block;"><el-switch v-model="sentenceDeadEnable" />&nbsp;{{ $t('common.sentencedead') }}</label>
              <el-input type="textarea" v-if="!sentenceDeadEnable" :disabled="true" :row="8"></el-input>
              <el-input type="textarea" v-model="challenge.sentence_dead[lang]" v-if="sentenceDeadEnable" :row="8"></el-input>
            </div>

            <div class="form-group form-group-container-sentence_survive" style="text-align:left;">
              <label style="margin-bottom:8px;display:block;"><el-switch v-model="sentenceSurviveEnable" />&nbsp;{{ $t('common.sentencesurvive') }}</label>
              <el-input type="textarea" v-if="!sentenceSurviveEnable" :disabled="true" :row="8"></el-input>
              <el-input type="textarea" v-model="challenge.sentence_survive[lang]" v-if="sentenceSurviveEnable" :row="8"></el-input>
            </div>
          </div>
        </div>
      </div>

      <div v-show="step === 3"
           style="display:flex;align-items:center">
        <div style="flex:1; text-align:center; border-right:1px dashed #aeaeae; padding:0 28px">
          <div style="margin: 36px 0">
            <font-awesome-icon icon="trophy" style="font-size:120px;color:#f5d76e;"></font-awesome-icon>
            <h1>{{$t('challenge.modal.campaign')}}</h1>
          </div>
          <div style="line-height:1.8em;word-break: initial;">
            {{$t('challenge.modal.description_3')}}
          </div>
        </div>
        <div style="flex:1; text-align:center; padding:0 28px">
          <form-group label="Campaign" style="text-align:left">
            <template slot="input">
              <div style="display:flex;">
                <el-select v-model="campaignSelected" placeholder="Select" style="width:100%">
                  <el-option
                    v-for="campaign in campaigns"
                    :key="campaign.id"
                    :label="campaign.name[lang]"
                    :value="campaign.id">
                  </el-option>
                </el-select>
                <el-button @click="campaignSelected = null">
                  <font-awesome-icon icon="trash"></font-awesome-icon>
                </el-button>
              </div>
            </template>
          </form-group>
        </div>
      </div>

      <div v-if="step === 4">
        <simulator @config="getConfig" @reset="reset" :id="challenge.id"></simulator>
      </div>
    </el-form>
    <span slot="footer">
      <el-button @click="$emit('close')"> {{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="nextStep" :disabled="isReady" v-if="step < 4">{{ $t('common.next') }}</el-button>
      <el-button type="primary" @click="save" :loading="saving"  v-if="step === 4" :disabled="!challenge.activationdate || !challenge.deactivationdate || !challenge.events.length || !challenge.energy">{{ $t('common.save') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import LibraryManager from '../libraries/library-manager.vue'
import { mapGetters, mapActions } from 'vuex'
import simulator from '@/components/challenge/challenge-simulator.vue'
import formGroup from '@/components/layouts/form-group.vue'

export default {
  components: { LibraryManager, simulator, formGroup },
  props: ['id'],
  data () {
    return {
      open: true,
      saving: false,
      challenge: {},
      libraryOpened: false,
      period: null,
      events: null,
      chartData: null,
      step: 1,
      config: null,

      energyTotal: 0,

      sentenceStartEnable: false,
      sentenceDeadEnable: false,
      sentenceSurviveEnable: false,

      campaigns: [],
      campaignSelected: null
    }
  },

  computed: {
    ...mapGetters('account', {
      site: 'currentSite',
      lang: 'defaultLang'
    }),
    ...mapGetters('events', {
      getEventById: 'getById'
    }),
    ...mapGetters('challenges', {
      getById: 'getById'
    }),
    width () {
      return '900px'
    },
    isReady () {
      if (this.step === 1) {
        if (!this.challenge.name[this.lang] || !this.challenge.description[this.lang] || !this.challenge.media.id) {
          return true
        }
      }

      return false
    }
  },
  methods: {
    ...mapActions('challenges', ['addChallenge', 'updateChallenge']),
    ...mapActions('campaigns', ['loadCampaign']),

    reset () {
      this.challenge.activationdate = null
      this.challenge.deactivationdate = null
      this.challenge.events = []
    },

    nextStep () {
      if (this.step === 2) {
        if (!this.sentenceStartEnable) { this.challenge.sentence_start = null }
        if (!this.sentenceDeadEnable) { this.challenge.sentence_dead = null }
        if (!this.sentenceSurviveEnable) { this.challenge.sentence_survive = null }
      }

      this.step++
    },
    save () {
      if (this.campaignSelected) {
        this.challenge.category = {id: this.campaignSelected}
      } else {
        this.challenge.category = null
      }

      if (this.challenge.id) {
        this.updateChallenge({challenge: this.challenge})
          .then((result) => {
            this.$emit('close')
          }).catch(e => {
            this.$notify.error({
              title: this.$root.$t('api.' + e.response.data.code + '.title'),
              message: this.$root.$t('api.' + e.response.data.code + '.message')
            })
          })
      } else {
        this.addChallenge({challenge: this.challenge})
          .then((result) => {
            this.$emit('close')
          }).catch(e => {
            this.$notify.error({
              title: this.$root.$t('api.' + e.response.data.code + '.title'),
              message: this.$root.$t('api.' + e.response.data.code + '.message')
            })
          })
      }
    },

    imgSelected (media) {
      this.challenge.media = media
      this.libraryOpened = !this.libraryOpened
    },
    getConfig ({ energy, activationdate, deactivationdate, events }) {
      this.challenge.activationdate = activationdate
      this.challenge.deactivationdate = deactivationdate
      this.challenge.energy = energy
      this.challenge.events = []
      for (let id in events) {
        let event = {
          alias: this.getEventById(id).alias,
          damage: events[id]
        }
        this.challenge.events.push(event)
      }
    }
  },
  created () {
    if (!this.id) {
      this.challenge = {
        activationdate: null,
        deactivationdate: null,
        sentence_start: {},
        sentence_dead: {},
        sentence_survive: {},
        name: {},
        status: 'draft',
        description: {},
        energy: 0,
        events: [],
        media: {
          url: process.env.API + '/media/default/' + this.site.sitekey + '/achievement/'
        }
      }
    } else {
      var c = JSON.parse(JSON.stringify(this.getById(this.id)))
      delete c.status
      delete c.sitekey
      delete c.avatar

      this.challenge = c

      this.campaignSelected = c.category && c.category.id ? c.category.id : null

      if (!c.sentence_start) { this.challenge.sentence_start = {} } else { this.sentenceStartEnable = true }

      if (!c.sentence_dead) { this.challenge.sentence_dead = {} } else { this.sentenceDeadEnable = true }

      if (!c.sentence_survive) { this.challenge.sentence_survive = {} } else { this.sentenceSurviveEnable = true }
    }

    if (this.site) {
      this.loadCampaign()
        .then((result) => {
          this.campaigns = result
        })
    }
  },
  mounted () {
    if (this.site) {
      this.loadCampaign()
        .then((result) => {
          this.campaigns = result
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.form-group-container {
  display: grid;
  grid-template-columns: 240px 1fr;
  grid-gap: 24px;
}
.form-group-container-media {
  text-align: left;
  > img {
    margin: 0 auto 12px;
    width: 120px;
    max-height: 400px;
    border-radius: 4px;
  }
  > button {
  }
}
</style>



// WEBPACK FOOTER //
// src/components/challenge/challenge-form.vue